import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import ConversationMessage from './ConversationMessage';
import ConversationForm from './ConversationForm';
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  inner: {
    padding: theme.spacing(2)
  }
}));
function ConversationMessages({ messages, className }) {
  const classes = useStyles(); 

  return (
    <div
      className={clsx(classes.root, className)}
    >
        <div className={classes.inner}>
          {messages.map((message, index) => {
            return (
              <ConversationMessage
                key={`${message.id}-${index}`}
                message={message} //
              />
            );
          })}
        </div>
        <Divider />
        <ConversationForm messages={messages} />
      
    </div>
  );
}

ConversationMessages.propTypes = {
  className: PropTypes.string,
  messages: PropTypes.array.isRequired
};

export default ConversationMessages;
